import { MetaMenuType } from '@hdms/shared/page-frame/types';

export const FULL_META_ITEMS = [MetaMenuType.CART, MetaMenuType.LANG, MetaMenuType.CURRENCY, MetaMenuType.CONTACT];
export const COMPRESSED_META_ITEMS = [MetaMenuType.LANG, MetaMenuType.CONTACT];

export enum ContactTabType {
  SELF_SERVICE = 'selfService',
  CALL_US = 'callUs',
  CALL_BACK = 'letUsCallYou',
  LIVE_CHAT = 'liveChat',
  SEND_MESSAGE = 'sendMessage',
  FIND_STORE = 'findStore'
}

export const CONTACT_US_TABS = [
  ContactTabType.SELF_SERVICE,
  ContactTabType.CALL_US,
  ContactTabType.CALL_BACK,
  ContactTabType.LIVE_CHAT,
  ContactTabType.SEND_MESSAGE,
  ContactTabType.FIND_STORE
];

export const CONTACT_US_HASHES = {
  '#contact': ContactTabType.CALL_US,
  '#overlay/contact': ContactTabType.CALL_US,
  '#overlay/contact/callus': ContactTabType.CALL_US,
  '#overlay/contact/callback': ContactTabType.CALL_BACK,
  '#overlay/contact/livechat': ContactTabType.LIVE_CHAT,
  '#overlay/contact/sendmessage': ContactTabType.SEND_MESSAGE
};

export const CONSENT_POPUP_HASH = '#DidomiPopup';
